export const SET_PROFILE = 'SET_PROFILE';

export function changeSidebarPosition(payload) {
    return {
      type: SET_PROFILE,
      payload: payload,
    };
  }